import { z } from "zod";
import { DescriptionSchema } from "./common-schema";

export const FeedbackReq = z.object({
  description: DescriptionSchema,
});
